module.exports = {"230781100":"铁力镇","230781101":"双丰镇","230781102":"桃山镇","230781105":"神树镇","230781106":"日月峡镇","230781200":"年丰朝鲜族乡","230781201":"工农乡","230781202":"王杨乡","230781400":"铁力林业局","230781401":"双丰林业局","230781402":"桃山林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230781.json
// module id = 854
// module chunks = 0